import { render } from "./PriceTablePageList.vue?vue&type=template&id=79ecd4fc&scoped=true&ts=true"
import script from "./PriceTablePageList.vue?vue&type=script&lang=ts"
export * from "./PriceTablePageList.vue?vue&type=script&lang=ts"

import "./PriceTablePageList.vue?vue&type=style&index=0&id=79ecd4fc&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ecd4fc"]])

export default __exports__